export default __webpack_public_path__ + "static/media/TwitterLogoBlue.bf36f3f6.svg";